// Open modal parameter name
export const KPI_MODAL_PARAM = 'openModal';

// Open modal parameter values
export const KPI_MODAL_VALUES = {
  CREATE: 'createKpi',
  VIEW: 'viewKpi',
} as const;

export type KPIModalValue = (typeof KPI_MODAL_VALUES)[keyof typeof KPI_MODAL_VALUES];

// Open modal parameter name for KPI ID
export const KPI_ID_PARAM = 'kpiId';

// Open modal parameter name for team ID
export const TEAM_ID_PARAM = 'teamId';

// Open modal parameter name for KPI location
export const KPI_LOCATION_PARAM = 'kpiLocation';

// Open modal parameter values for KPI location
export const KPI_LOCATION_VALUES = {
  NAV_CREATE: 'navigationCreateButton',
  TEAM_PAGE_ADD: 'teamPageAddButton',
  TEAM_PAGE_ROW: 'teamPageTableRow',
  TEAM_PAGE_TAB: 'teamPageTab',
  OKR_PAGE_ADD: 'okrPageAddButton',
  OKR_PAGE_ROW: 'okrPageTableRow',
  OKR_PAGE_TRAY: 'okrPageTray',
  RBR_TRAY: 'rbrTray',
  VIEW_KPI_UPDATE: 'viewKpiUpdateButton',
  TOAST_CREATE_ANOTHER: 'notificationCreateAnotherButton',
  TOAST_VIEW_KPI: 'notificationViewKpiButton',
  RELATIONSHIP_MAP: 'relationshipMap',
} as const;

export type KPILocationValue = (typeof KPI_LOCATION_VALUES)[keyof typeof KPI_LOCATION_VALUES];
